<section>
    <img width="100%" src="/assets/images/micrositio/homepage/HOME_027.jpg">
    <br>
    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
</section>
<div class="container">
    <div class="row marg">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20 text-grey">
                        RECORRIDOS
                    </p>
                    <p class="fontMS700 colorPrincipal font-40" style="line-height: 2.5rem;">
                        COMUNIDADES IMAGINADAS
                        <br>
                    </p>
                </div>
                <div class="col-sm-5">
                    <div id="sharePic">
                        <a (click)="test.toggle()" mdbWavesEffect>
                            <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
                        </a>
                        <div mdbCollapse #test="bs-collapse">
                            <div class="divShared">
                                &nbsp;
                                &nbsp;
                                <a target="_blank"
                                    href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica3">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica3">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica3">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20">
                        <br>
                        <span class="fontMS500 font-22">
                            SOMOS UN PAÍS HETEROGÉNEO Y A LO LARGO DE NUESTRA HISTORIA HA HABIDO DIVERSOS INTENTOS DE
                            FORJAR UNA IDENTIDAD COMÚN.
                            <br><br>
                        </span>
                        En este recorrido se reúnen documentos que nos permiten
                        reflexionar sobre la construcción de la identidad nacional y de determinados grupos dentro
                        de nuestra sociedad.

                        Cada tema explora diferentes tipos de documentos. Textos religiosos, innovadores estudios
                        académicos, cartillas pedagógicas y partituras que reflejan la diversidad lingüística,
                        cultural y social del país. También escenifican tensiones y desencuentros. La pregunta
                        persiste: ¿Quiénes somos?
                        <br><br>
                    </p>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4">
                    <p class="fontMS500 font-22">
                        <br> OTROS RECORRIDOS <br>
                        <span class="font-20 text-grey">
                            <u>
                                <a style="color: inherit;" (click)="creadores()">Creadores</a><br>

                                <a style="color: inherit;" (click)="miradasArta()">Miradas desde el Arte</a><br>

                                <a style="color: inherit;" (click)="transiciones()">Transiciones y transformaciones <br>
                                    sociales </a><br>
                            </u>
                        </span>
                    </p>
                </div>
            </div>
            <p class="fontMS500 font-30">
                TEMAS
            </p>
            <div class="row">
                <div class="col-sm-8">
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Imprenta()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_027f.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Imprenta()">
                                <p class="fontMS700 font-24">
                                    IMPRENTA, LOS INCUNABLES Y ESTAMPAS EN EL VIRREINATO DEL PERÚ
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Garcilaso()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_027e.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Garcilaso()">
                                <p class="fontMS700 font-24">
                                    INCA GARCILASO DE LA VEGA
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Recuerdo()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_052a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Recuerdo()">
                                <p class="fontMS700 font-24">
                                    RECUERDO DE LA MONARQUÍA PERUANA Ó
                                    BOSQUEJO DE LA HISTORIA DE LOS INCAS.
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Gramaticas()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_027a.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Gramaticas()">
                                <p class="fontMS700 font-24">
                                    GRAMÁTICAS, CATECISMOS Y VOCABULARIOS<br>
                                    EN LENGUAS ORIGINARIAS
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="MiradasAntiguoPeru()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_027b.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="MiradasAntiguoPeru()">
                                <p class="fontMS700 font-24">
                                    MIRADAS AL ANTIGUO PERÚ
                                    A INICIOS DEL <br>SIGLO XX

                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="LaEducacion()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_027c.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="LaEducacion()">
                                <p class="fontMS700 font-24">
                                    LA EDUCACIÓN EXPERIMENTAL
                                    EN EL ALTIPLANO (1930-1950)
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Himnos()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_027d.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Himnos()">
                                <p class="fontMS700 font-24">
                                    COMUNIDADES CANTADAS<br>
                                    LAS COMPOSICIONES DE HIMNOS
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Memoria()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_053a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Memoria()">
                                <p class="fontMS700 font-24">
                                    MEMORIA RECUPERADA<br>
                                    LOS LIBROS DEVUELTOS POR CHILE
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Lenguas()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_056a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Lenguas()">
                                <p class="fontMS700 font-24">
                                    LENGUAS ORIGINARIAS<br>
                                    LA PERSISTENCIA DE LA PALABRA
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    
                </div>
                <div class="col-sm-4">
                </div>
            </div>
        </div>
    </div>
</div>